import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3865f9d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-arrow-left",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "cor_texto_1" }, "Carregando...", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "background_1 card p-4"
}
const _hoisted_6 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "*", -1))
const _hoisted_8 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "*", -1))
const _hoisted_10 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-competitor-post-cpf",
  class: "form-label cor_texto_1"
}, "CPF: ", -1))
const _hoisted_13 = { class: "d-flex w-100" }
const _hoisted_14 = {
  class: "d-flex position-relative align-items-center justify-content-center",
  style: {"width":"2.5rem","margin-left":"-2.5rem"}
}
const _hoisted_15 = {
  key: 0,
  class: "spinner-border text-dark",
  role: "status",
  style: {"width":"1rem","height":"1rem"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-check-circle",
  "aria-hidden": "true",
  style: {"color":"var(--cor_indicadores_1)","font-size":"1.25rem"}
}, null, -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = {
  for: "form-competitor-post-nome",
  class: "form-label cor_texto_1"
}
const _hoisted_23 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"padding":"0px 4px","border-radius":"50%","border":"1px solid black","font-size":"9px !important"},
  class: "fw-bolder cor_texto_1"
}, "?", -1))
const _hoisted_25 = { class: "col-md-3" }
const _hoisted_26 = {
  for: "form-competitor-post-nome",
  class: "form-label cor_texto_1"
}
const _hoisted_27 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"padding":"0px 4px","border-radius":"50%","border":"1px solid black","font-size":"9px !important"},
  class: "fw-bolder cor_texto_1"
}, "?", -1))
const _hoisted_29 = { class: "col-md-3" }
const _hoisted_30 = {
  for: "form-competitor-post-telefone",
  class: "form-label cor_texto_1"
}
const _hoisted_31 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_32 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_33 = { class: "col-md-4" }
const _hoisted_34 = {
  for: "form-competitor-post-e-mail",
  class: "form-label cor_texto_1"
}
const _hoisted_35 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_36 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_37 = { class: "col-md-5" }
const _hoisted_38 = {
  for: "form-competitor-put-e-mail",
  class: "form-label cor_texto_1"
}
const _hoisted_39 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_40 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_41 = { class: "col-12" }
const _hoisted_42 = {
  key: 0,
  class: "d-flex p-2 align-items-center gap-3",
  style: {"border":".1rem solid var(--cor_background_2)","border-radius":".25rem","background-color":"var(--cor_background_3)","color":"var(--cor_texto_1)"}
}
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { key: 2 }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  style: {"color":"var(--cor_icones_1)"},
  "aria-hidden": "true"
}, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-save",
  style: {"color":"var(--cor_icones_1)"},
  "aria-hidden": "true"
}, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  style: {"color":"var(--cor_icones_1)"},
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CampHeader = _resolveComponent("CampHeader")!
  const _component_CampFormHeader = _resolveComponent("CampFormHeader")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_CampFormRackSubmitBtn = _resolveComponent("CampFormRackSubmitBtn")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CampHeader, null, {
      title: _withCtx(() => [
        _createTextVNode("Criar Consultor")
      ]),
      button: _withCtx(() => [
        _createVNode(_component_router_link, {
          to: `/consultores`,
          class: "btn btn_background_1"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createTextVNode(" Voltar ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.postObject.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.postObject.data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("form", {
            class: "row g-4",
            id: "form-competitor-post",
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmitForm && _ctx.onSubmitForm(...args)), ["prevent"]))
          }, [
            _createVNode(_component_CampFormHeader, null, {
              default: _withCtx(() => [
                _createTextVNode("1. Dados gerais")
              ]),
              _: 1
            }),
            (_ctx.isRequiredField)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createTextVNode(" Preencha os campos marcados com "),
                  _hoisted_7
                ]))
              : _createCommentVNode("", true),
            (_ctx.isRequiredNameComplete)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createTextVNode(" Nome completo obrigatório "),
                  _hoisted_9
                ]))
              : _createCommentVNode("", true),
            (_ctx.isInvalidFieldWarning)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Verifique também se são informações válidas. "))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createVNode(_component_el_input, {
                  class: "position-relative w-100",
                  modelValue: _ctx.postObject.data.cpf,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.postObject.data.cpf) = $event)),
                  type: "text",
                  name: "form-competitor-post-cpf",
                  id: "form-competitor-post-cpf"
                }, null, 8, ["modelValue"]), [
                  [_directive_maska, {mask:'###.###.###-##'}]
                ]),
                _createElementVNode("div", _hoisted_14, [
                  (_ctx.userAppCPF.isLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                    : _createCommentVNode("", true),
                  (_ctx.userAppCPF.available)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 1,
                        class: "item",
                        effect: "dark",
                        placement: "bottom"
                      }, {
                        content: _withCtx(() => [
                          _createTextVNode(" Cpf disponível. ")
                        ]),
                        default: _withCtx(() => [
                          _hoisted_16
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.userAppCPF.data && !_ctx.userAppCPF.available)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 2,
                        class: "item",
                        effect: "dark",
                        placement: "bottom"
                      }, {
                        content: _withCtx(() => [
                          (_ctx.userAppCPF.data.id_role == 7)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, "CPF de um vendedor já cadastrado. O vendedor será promovido a consultor"))
                            : _createCommentVNode("", true),
                          (_ctx.userAppCPF.data.id_role == 6)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, "CPF de um moderador já cadastrado. O moderador será promovido a consultor"))
                            : _createCommentVNode("", true),
                          (_ctx.userAppCPF.data.id_role == 8)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Consultor já está cadastrado"))
                            : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("i", {
                            class: "fa fa-exclamation-triangle",
                            "aria-hidden": "true",
                            style: _normalizeStyle(`color: var(${_ctx.userAppCPF.data.id_role == 8 ? '--cor_indicadores_2' : '--cor_indicadores_3'})`)
                          }, null, 4)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.isInvalidField.cpf)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, " Informe um cpf válido "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, [
                _createTextVNode("Nome: "),
                (_ctx.isRequiredField)
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_23, "*"))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_tooltip, {
                  class: "item",
                  effect: "dark",
                  placement: "bottom"
                }, {
                  content: _withCtx(() => [
                    _createTextVNode(" O nome completo é necessário para geração do cartão de pagamento. ")
                  ]),
                  default: _withCtx(() => [
                    _hoisted_24
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_el_input, {
                modelValue: _ctx.postObject.data.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.postObject.data.name) = $event)),
                clearable: "",
                type: "text",
                name: "form-competitor-post-nome",
                id: "form-competitor-post-nome",
                ref: "fieldNameRef"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("label", _hoisted_26, [
                _createTextVNode("Data de nascimento: "),
                (_ctx.isRequiredField)
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_27, "*"))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_tooltip, {
                  class: "item",
                  effect: "dark",
                  placement: "bottom"
                }, {
                  content: _withCtx(() => [
                    _createTextVNode(" A data de nascimento é necessária para geração do cartão de pagamento. ")
                  ]),
                  default: _withCtx(() => [
                    _hoisted_28
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_el_input, {
                modelValue: _ctx.postObject.data.birth_date,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.postObject.data.birth_date) = $event)),
                clearable: "",
                type: "date",
                name: "form-competitor-post-nome",
                id: "form-competitor-post-nome"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("label", _hoisted_30, [
                _createTextVNode("Telefone: "),
                (_ctx.isRequiredField)
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_31, "*"))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.userAppCPF.isLoading)
                ? (_openBlock(), _createBlock(_component_el_input, {
                    key: 0,
                    modelValue: _ctx.postObject.data.tel,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.postObject.data.tel) = $event)),
                    clearable: "",
                    type: "text",
                    name: "form-competitor-post-telefone",
                    id: "form-competitor-post-telefone"
                  }, null, 8, ["modelValue"]))
                : _withDirectives((_openBlock(), _createBlock(_component_el_input, {
                    key: 1,
                    modelValue: _ctx.postObject.data.tel,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.postObject.data.tel) = $event)),
                    clearable: "",
                    type: "text",
                    name: "form-competitor-post-telefone",
                    id: "form-competitor-post-telefone"
                  }, null, 8, ["modelValue"])), [
                    [_directive_maska, _ctx.postObject.data.tel.replace(/[^\d]+/g, '').length < 13 ? {mask:'+55 (##) ####-####'} : {mask:'+55 (##) # ####-####'}]
                  ]),
              (_ctx.isInvalidField.phoneNumber)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, " Informe um telefone válido "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("label", _hoisted_34, [
                _createTextVNode("E-mail: "),
                (_ctx.isRequiredField)
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_35, "*"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_el_input, {
                modelValue: _ctx.postObject.data.email,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.postObject.data.email) = $event)),
                clearable: "",
                type: "text",
                name: "form-competitor-post-e-mail",
                id: "form-competitor-post-e-mail"
              }, null, 8, ["modelValue"]),
              (_ctx.isInvalidField.mail)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, " Informe um email válido "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("label", _hoisted_38, [
                _createTextVNode("Loja: "),
                (_ctx.isRequiredField)
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_39, "*"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_el_select, {
                onClick: ($event: any) => (''),
                id: "form-store-post-profile",
                filterable: "",
                "default-first-option": "",
                "reserve-keyword": false,
                placeholder: "Selecione a loja...",
                style: {"margin-top":"0","width":"100%"},
                modelValue: _ctx.postObject.data.id_store,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.postObject.data.id_store) = $event)),
                "no-data-text": 'Nenhuma loja disponível'
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeOptions, (el) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: el.id,
                      value: el.id,
                      label: el.fantasy_name + ' - ' + el.cnpj
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (_ctx.isInvalidField.storeSelected)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, " É necessário selecionar uma loja. "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_41, [
              (_ctx.userAppCPF.data)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _createElementVNode("i", {
                      class: "fa fa-exclamation-triangle",
                      "aria-hidden": "true",
                      style: _normalizeStyle(`color: var(${_ctx.userAppCPF.data.id_role == 8 ? '--cor_indicadores_2' : '--cor_indicadores_3'})`)
                    }, null, 4),
                    (_ctx.userAppCPF.data.id_role == 7)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_43, "CPF de um vendedor já cadastrado. O vendedor será promovido a consultor"))
                      : _createCommentVNode("", true),
                    (_ctx.userAppCPF.data.id_role == 6)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_44, "CPF de um moderador já cadastrado. O moderador será promovido a consultor"))
                      : _createCommentVNode("", true),
                    (_ctx.userAppCPF.data.id_role == 8)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_45, "Consultor já está cadastrado"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_CampFormRackSubmitBtn, null, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn background_btn_1",
                  style: {"color":"var(--cor_icones_1)"},
                  disabled: _ctx.userAppCPF.data && _ctx.userAppCPF.data.id_role == 8 ? true : false
                }, [
                  (_ctx.userAppCPF.data)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.userAppCPF.data.id_role == 8)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_47,
                              _createTextVNode(" Cadastrar ")
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _hoisted_48,
                              _createTextVNode(" Salvar como consultor ")
                            ], 64))
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_49,
                        _createTextVNode(" Cadastrar ")
                      ], 64))
                ], 8, _hoisted_46)
              ]),
              _: 1
            })
          ], 32)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}